var _path, _path2, _polygon, _path3, _path4, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpdateAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-110"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 337.58,
    rx: 228.23,
    ry: 135.42,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.09,250.87l-9.32-5.38a8,8,0,0,0-8,0L112.58,367.37a3,3,0,0,0,0,5.11l9.32,5.38a8,8,0,0,0,8,0l54.63-32,33.87,19.53a6.87,6.87,0,0,0,6.85,0L284,331.6a2.08,2.08,0,0,0,0-3.6l-34.26-19.74L341.09,256A3,3,0,0,0,341.09,250.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 322.96,
    cy: 403.72,
    rx: 46.4,
    ry: 25.21,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.37,76l-7.57,4.36v-6c0-3.49-2.85-4.7-6.34-2.69l-.26.16a13.16,13.16,0,0,0-4,3.8C142,69.7,137,67.72,131,71.2l-.46.27C124.34,75,119.3,83,119.3,89.15v10.5l-7,4c-3,1.71-5.38,5.53-5.38,8.49s2.42,4,5.38,2.27l9.3-5.37h0l18.22-10.52h0l20.52-11.85c3-1.71,5.38-5.53,5.38-8.49S163.33,74.24,160.37,76Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.16,66.88l-5.14,3V65.76c0-2.36-1.93-3.18-4.3-1.81l-.18.1a9,9,0,0,0-2.74,2.58c-.14-4-3.5-5.34-7.59-3l-.32.18c-4.18,2.42-7.6,7.81-7.6,12V83L76.55,85.7a7.59,7.59,0,0,0-3.65,5.76c0,2,1.64,2.7,3.65,1.54l6.31-3.64h0l12.36-7.14h0l13.93-8a7.59,7.59,0,0,0,3.65-5.76C112.81,66.41,111.17,65.72,109.16,66.88Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.29,275.33l2.52,1.13.95.43,2.12.94s.41-14,4.8-24.33,12.23-19.92,13.57-25.7-3.07-8-3.07-8c-9.33-3.55-18.38,10-20.89,21.32S420.29,275.33,420.29,275.33Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.29,275.33l2.52,1.13.95.43,2.12.94s.41-14,4.8-24.33,12.23-19.92,13.57-25.7-3.07-8-3.07-8c-9.33-3.55-18.38,10-20.89,21.32S420.29,275.33,420.29,275.33Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.81,276.46l.95.43c-2-39.35,15.45-53.3,15.63-53.44a.44.44,0,0,0,.08-.64.45.45,0,0,0-.65-.09C438.64,222.86,421,236.94,422.81,276.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.22,271.2c-.15,3.61,3.74,10.1,3.74,10.1l6.67,4.72.88.62,9.77,6.92a8.84,8.84,0,0,0,7.36-5c2.6-5-1.15-10.39-.07-13.85s7.72-4.47,7.44-8.51-6.86-8.45-5.85-12.05,3.25-5,4-8a3.82,3.82,0,0,0-3-4.94c-2.24-.39-5.11.12-8,2.87s-4,4.64-7.23,5.44-6.64.29-8.37,3,.29,8.23-1.51,10.39S421.36,267.58,421.22,271.2Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.63,286l.88.62a78.27,78.27,0,0,1,4.22-20.05c5.58-1.68,13.12-1,13.19-1a.46.46,0,0,0,.51-.42.48.48,0,0,0-.42-.51c-.31,0-7.25-.63-12.89.85,5.21-14,12.72-20.92,12.84-21a.46.46,0,1,0-.63-.68c-.11.1-8,7.41-13.35,22.11a.58.58,0,0,0-.09.29A79.36,79.36,0,0,0,431.63,286Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.42,317.3s0,2.94-2,4.08l-57.87,33a6.31,6.31,0,0,1-6.28,0L191.5,339.12a3.13,3.13,0,0,1-1.56-3.17l2.82-19.44,4.32,2.61,61-33L257,296a11.17,11.17,0,0,0,5.69,11l1.2.67L279,316c-.11-.45-.17-.75-.17-.75l3.5-3S284.42,313.26,284.42,317.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.42,317.3s0,2.94-2,4.08l-57.87,33a6.33,6.33,0,0,1-2.52.81v-7.82l6.22-16.3s27.23-18,35.68-23.43L279,316c-.11-.45-.17-.75-.17-.75l3.5-3S284.42,313.26,284.42,317.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.39,315.71l-57,32.57a6.26,6.26,0,0,1-6.2,0L197,335.79a2.86,2.86,0,0,1-.79-.66,3,3,0,0,1-.74-2.47l2.77-19.18L258.42,281l-1.05,9.77A11,11,0,0,0,263,301.53l19.39,10.73A2,2,0,0,1,282.39,315.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.54,298.54l-63.29,36.59a3,3,0,0,1-.74-2.47l2.77-19.18L258.42,281l-1.05,9.77A11,11,0,0,0,259.54,298.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,52.85c0,.61-6.56,4.14-9.94,5.93V225.93a5.93,5.93,0,0,1-3,5.14L117.92,354.29l1.6,10.95c-2.61,1.06-6.43-.11-8.28-1.19a8.21,8.21,0,0,1-4.16-6.32V177.47a5.57,5.57,0,0,1,1.33-3.6,5.25,5.25,0,0,1,1.46-1.22L329.19,45s.14-.07.4-.17l.23-.08A9.37,9.37,0,0,1,338,46.25C342.59,49.35,342.49,52.05,342.5,52.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.5,52.85c0,.61-6.56,4.14-9.94,5.93V72L127.37,185.12l-19-11.25a5.25,5.25,0,0,1,1.46-1.22L329.19,45s.14-.07.4-.17l.23-.08A9.37,9.37,0,0,1,338,46.25C342.59,49.35,342.49,52.05,342.5,52.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.51,53V232a5.94,5.94,0,0,1-3,5.15l-220,128.08a1.65,1.65,0,0,1-2.47-1.43V183.57a5.58,5.58,0,0,1,2.77-4.83L339.15,51.1A2.24,2.24,0,0,1,342.51,53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.49,63a2.08,2.08,0,0,1,3.13,1.8V219.13a5.56,5.56,0,0,1-2.75,4.79L127.24,343a1.53,1.53,0,0,1-2.3-1.33V186.21a5.19,5.19,0,0,1,2.58-4.49",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.92,289.87l-21.58,12.56a2.25,2.25,0,0,1-3.39-1.95h0a6.27,6.27,0,0,1,3.12-5.42l20.11-11.71a2.74,2.74,0,0,1,4.12,2.37h0A4.81,4.81,0,0,1,239.92,289.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,157.81l-1.27.73c-.43.25-.79.16-.89-.2a9.86,9.86,0,0,0-2.38-4.39c-.22-.24-.18-.73.12-1.21l.89-1.4c.41-.65.41-1.32,0-1.49l-3.67-1.55c-.41-.18-1.08.21-1.49.86l-.89,1.4a1.46,1.46,0,0,1-1.14.77,15.92,15.92,0,0,0-5.76.95c-.42.15-.72,0-.72-.47v-1.27c0-.58-.47-.78-1.06-.44l-5.19,3a2.18,2.18,0,0,0-1,1.66V156a1.9,1.9,0,0,1-.73,1.31,42,42,0,0,0-5.76,5.71c-.36.44-.83.66-1.14.54l-.89-.38c-.41-.17-1.08.21-1.49.86l-3.67,5.79c-.41.65-.41,1.32,0,1.49l1.1.64a1.1,1.1,0,0,1-.09.81,33.37,33.37,0,0,0-2.38,7.13,2,2,0,0,1-.89,1.24l-1.27.73a2.19,2.19,0,0,0-1.05,1.66v5.2c0,.58.47.78,1.05.44l1.27-.73c.43-.25.79-.15.89.21a9.91,9.91,0,0,0,2.38,4.39c.23.23.18.73-.12,1.21l-.89,1.4c-.41.65-.41,1.32,0,1.49l5.37,3.1,1.53-3.1a4.93,4.93,0,0,0,.23-1.48h.06a15.64,15.64,0,0,0,5.76-.95c.42-.14.73,0,.73.47v1.27c0,.59.47.79,1,.45l5.19-3a2.18,2.18,0,0,0,1.06-1.66V191a1.88,1.88,0,0,1,.72-1.31,41.34,41.34,0,0,0,5.76-5.7c.36-.44.83-.67,1.14-.54l.89.38c.41.17,1.08-.21,1.49-.86l3.67-5.8c.41-.65.41-1.31,0-1.49l-.89-.37c-.3-.13-.34-.58-.12-1.07a33.26,33.26,0,0,0,2.38-7.14,2,2,0,0,1,.89-1.23l1.27-.73a2.19,2.19,0,0,0,1-1.67v-5.19C234,157.68,233.51,157.48,232.93,157.81Zm-9.77,10.62c-.59,5.45-4.73,12-9.85,15.46-6.72,4.6-12.39,2.63-12.39-3.95,0-6.15,5-14,11.16-17.6C218.68,158.53,223.94,161.23,223.16,168.43Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.93,157.82l-1.27.73c-.43.24-.79.15-.89-.21A9.94,9.94,0,0,0,228.4,154c-.23-.24-.19-.74.12-1.21l.88-1.4c.42-.65.42-1.32,0-1.5l-3.67-1.54c-.41-.18-1.08.21-1.49.86l-.88,1.39a1.48,1.48,0,0,1-1.14.78,14.12,14.12,0,0,0-3.79.39,16.54,16.54,0,0,0-2,.56c-.42.14-.72,0-.72-.47v-1.27a.56.56,0,0,0-.31-.57,1,1,0,0,0-.75.13l-5.19,3a2.2,2.2,0,0,0-1.06,1.66V156a1.86,1.86,0,0,1-.72,1.3,41.9,41.9,0,0,0-5.76,5.7c-.36.45-.84.68-1.14.55l-.88-.38c-.42-.18-1.09.21-1.49.86l-3.67,5.8c-.42.65-.42,1.31,0,1.48l1.1.64a1.1,1.1,0,0,1-.11.82,33.62,33.62,0,0,0-2.37,7.12,2,2,0,0,1-.89,1.24l-1.27.74a2.19,2.19,0,0,0-1.06,1.66v5.19c0,.58.48.78,1.06.44l1.27-.73c.43-.24.79-.15.89.21a9.68,9.68,0,0,0,2.39,4.38c.22.25.17.73-.13,1.21l-.88,1.41c-.42.65-.42,1.32,0,1.5l5.36,3.09,1.54-3.09a5.13,5.13,0,0,0,.22-1.49H202a15.87,15.87,0,0,0,5.75-.94c.42-.16.72,0,.72.46v1.28c0,.58.48.78,1.06.44l5.19-3a2.16,2.16,0,0,0,1.06-1.66V191a1.88,1.88,0,0,1,.72-1.31A40.28,40.28,0,0,0,222.2,184c.38-.43.84-.66,1.14-.53l.9.38c.41.18,1.08-.22,1.49-.86l3.67-5.8c.42-.65.42-1.31,0-1.48l-.88-.39c-.31-.12-.35-.57-.13-1.07a33,33,0,0,0,2.38-7.13,2,2,0,0,1,.89-1.23l1.27-.74a2.18,2.18,0,0,0,1-1.66v-5.19C234,157.68,233.51,157.48,232.93,157.82Zm-9.77,10.61c-.58,5.45-4.73,12-9.86,15.46-6.71,4.61-12.39,2.63-12.39-3.95,0-6.16,5-14,11.17-17.6C218.68,158.53,223.94,161.23,223.16,168.43Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.94,160.77l-5.25-3.07-.14,3.07a28.92,28.92,0,0,0,2.76,2.29,11.49,11.49,0,0,0,1.33,0Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.67 196.99 214.04 200.09 214.27 197.18 211.47 196.79 208.67 196.99",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M232.93,157.81l-1.27.73c-.43.25-.79.16-.89-.2a9.86,9.86,0,0,0-2.38-4.39c-.22-.24-.18-.73.12-1.21l.89-1.4c.41-.65.41-1.32,0-1.49l-3.67-1.55c-.41-.18-1.08.21-1.49.86l-.89,1.4a1.46,1.46,0,0,1-1.14.77,15.92,15.92,0,0,0-5.76.95c-.42.15-.72,0-.72-.47v-1.27c0-.58-.47-.78-1.06-.44l-5.19,3a2.18,2.18,0,0,0-1,1.66V156a1.9,1.9,0,0,1-.73,1.31,42,42,0,0,0-5.76,5.71c-.36.44-.83.66-1.14.54l-.89-.38c-.41-.17-1.08.21-1.49.86l-3.67,5.79c-.41.65-.41,1.32,0,1.49l1.1.64a1.1,1.1,0,0,1-.09.81,33.37,33.37,0,0,0-2.38,7.13,2,2,0,0,1-.89,1.24l-1.27.73a2.19,2.19,0,0,0-1.05,1.66v5.2c0,.58.47.78,1.05.44l1.27-.73c.43-.25.79-.15.89.21a9.91,9.91,0,0,0,2.38,4.39c.23.23.18.73-.12,1.21l-.89,1.4c-.41.65-.41,1.32,0,1.49l5.37,3.1,1.53-3.1a4.93,4.93,0,0,0,.23-1.48h.06a15.64,15.64,0,0,0,5.76-.95c.42-.14.73,0,.73.47v1.27c0,.59.47.79,1,.45l5.19-3a2.18,2.18,0,0,0,1.06-1.66V191a1.88,1.88,0,0,1,.72-1.31,41.34,41.34,0,0,0,5.76-5.7c.36-.44.83-.67,1.14-.54l.89.38c.41.17,1.08-.21,1.49-.86l3.67-5.8c.41-.65.41-1.31,0-1.49l-.89-.37c-.3-.13-.34-.58-.12-1.07a33.26,33.26,0,0,0,2.38-7.14,2,2,0,0,1,.89-1.23l1.27-.73a2.19,2.19,0,0,0,1-1.67v-5.19C234,157.68,233.51,157.48,232.93,157.81Zm-9.77,10.62c-.59,5.45-4.73,12-9.85,15.46-6.72,4.6-12.39,2.63-12.39-3.95,0-6.15,5-14,11.16-17.6C218.68,158.53,223.94,161.23,223.16,168.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.93,157.82l-1.27.73c-.43.24-.79.15-.89-.21A9.94,9.94,0,0,0,228.4,154c-.23-.24-.19-.74.12-1.21l.88-1.4c.42-.65.42-1.32,0-1.5l-3.67-1.54c-.41-.18-1.08.21-1.49.86l-.88,1.39a1.48,1.48,0,0,1-1.14.78,14.12,14.12,0,0,0-3.79.39,16.54,16.54,0,0,0-2,.56c-.42.14-.72,0-.72-.47v-1.27a.56.56,0,0,0-.31-.57,1,1,0,0,0-.75.13l-5.19,3a2.2,2.2,0,0,0-1.06,1.66V156a1.86,1.86,0,0,1-.72,1.3,41.9,41.9,0,0,0-5.76,5.7c-.36.45-.84.68-1.14.55l-.88-.38c-.42-.18-1.09.21-1.49.86l-3.67,5.8c-.42.65-.42,1.31,0,1.48l1.1.64a1.1,1.1,0,0,1-.11.82,33.62,33.62,0,0,0-2.37,7.12,2,2,0,0,1-.89,1.24l-1.27.74a2.19,2.19,0,0,0-1.06,1.66v5.19c0,.58.48.78,1.06.44l1.27-.73c.43-.24.79-.15.89.21a9.68,9.68,0,0,0,2.39,4.38c.22.25.17.73-.13,1.21l-.88,1.41c-.42.65-.42,1.32,0,1.5l5.36,3.09,1.54-3.09a5.13,5.13,0,0,0,.22-1.49H202a15.87,15.87,0,0,0,5.75-.94c.42-.16.72,0,.72.46v1.28c0,.58.48.78,1.06.44l5.19-3a2.16,2.16,0,0,0,1.06-1.66V191a1.88,1.88,0,0,1,.72-1.31A40.28,40.28,0,0,0,222.2,184c.38-.43.84-.66,1.14-.53l.9.38c.41.18,1.08-.22,1.49-.86l3.67-5.8c.42-.65.42-1.31,0-1.48l-.88-.39c-.31-.12-.35-.57-.13-1.07a33,33,0,0,0,2.38-7.13,2,2,0,0,1,.89-1.23l1.27-.74a2.18,2.18,0,0,0,1-1.66v-5.19C234,157.68,233.51,157.48,232.93,157.82Zm-9.77,10.61c-.58,5.45-4.73,12-9.86,15.46-6.71,4.61-12.39,2.63-12.39-3.95,0-6.16,5-14,11.17-17.6C218.68,158.53,223.94,161.23,223.16,168.43Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "208.67 196.99 214.04 200.09 214.27 197.18 211.47 196.79 208.67 196.99"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,192.3l1.27-.74c.43-.24.79-.15.89.21a9.86,9.86,0,0,0,2.38,4.39c.22.23.18.73-.12,1.21l-.9,1.4c-.41.65-.41,1.32,0,1.49l3.68,1.56c.41.17,1.08-.22,1.49-.86l.89-1.41a1.47,1.47,0,0,1,1.14-.78,15.5,15.5,0,0,0,5.76-1c.42-.14.72.05.72.48v1.27c0,.58.47.78,1,.44l5.2-3a2.18,2.18,0,0,0,1-1.66v-1.27a1.88,1.88,0,0,1,.72-1.31,41.34,41.34,0,0,0,5.76-5.7c.37-.44.84-.66,1.14-.54l.89.38c.42.17,1.08-.21,1.49-.86l3.68-5.79c.41-.65.41-1.32,0-1.49l-.89-.38c-.31-.13-.35-.57-.12-1.07a33.37,33.37,0,0,0,2.38-7.13A2,2,0,0,1,237,169l1.26-.73a2.18,2.18,0,0,0,1.06-1.66v-5.2c0-.58-.47-.78-1.06-.44l-1.26.73c-.43.25-.8.15-.89-.21a9.86,9.86,0,0,0-2.38-4.39c-.23-.23-.19-.73.12-1.21l.89-1.4c.41-.65.41-1.32,0-1.49l-3.68-1.55c-.41-.18-1.07.21-1.49.86l-.88,1.4a1.53,1.53,0,0,1-1.14.78,15.7,15.7,0,0,0-5.77.94c-.42.15-.72,0-.72-.47v-1.26c0-.59-.47-.78-1-.45l-5.2,3a2.19,2.19,0,0,0-1,1.66v1.26a1.86,1.86,0,0,1-.72,1.31,42,42,0,0,0-5.76,5.71c-.37.44-.84.67-1.14.54l-.89-.38c-.41-.17-1.08.21-1.49.86l-3.68,5.8c-.41.65-.41,1.31,0,1.49l.89.37c.31.13.35.58.12,1.07a33.78,33.78,0,0,0-2.37,7.14,2,2,0,0,1-.89,1.23l-1.27.73a2.19,2.19,0,0,0-1,1.67v5.19C195.55,192.43,196,192.63,196.6,192.3Zm9.69-9.25c0-6.16,5-14.05,11.16-17.61,6.61-3.81,11.86-1.11,11.09,6.09-.59,5.45-4.74,12-9.86,15.47C212,191.6,206.29,189.62,206.29,183.05Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55,191.86a.57.57,0,0,0,.23.51l-1-.6-4.24-2.45-.07,0-.14-.12a.66.66,0,0,1-.13-.42v-5.19a2,2,0,0,1,.53-1.21l5.39,3.09a2,2,0,0,0-.53,1.22Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.78,153.07a1,1,0,0,0-.74.13l-5.19,3a2.12,2.12,0,0,0-.72.71l-5.36-3.13a2.29,2.29,0,0,1,.71-.68l5.19-3a1,1,0,0,1,.75-.13l.13.08,2.88,1.67Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.32,166.14l-.08.09c-.36.38-.78.57-1.06.45l-.9-.38-5.36-3.1.88.38c.3.13.78-.1,1.14-.55Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.11,151.4c-.42-.17-1.08.21-1.49.86l-.9,1.4a2.24,2.24,0,0,1-.27.34,1.23,1.23,0,0,1-.83.43h0l-5.37-3.1a1.48,1.48,0,0,0,1.14-.78l.88-1.39c.41-.65,1.08-1,1.49-.86Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.46 149.88 234.78 152.95 231.11 151.4 225.73 148.3 229.46 149.88",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.81,179.76l-.92.53c-.32.18-.58.11-.65-.15a7.37,7.37,0,0,0-1.74-3.21c-.17-.17-.14-.53.08-.89l.65-1c.31-.48.31-1,0-1.09l-2.68-1.14c-.3-.12-.79.16-1.09.63l-.65,1a1.1,1.1,0,0,1-.84.57,11.4,11.4,0,0,0-4.21.69c-.31.1-.53,0-.53-.35v-.92c0-.43-.34-.57-.77-.33l-3.8,2.2a1.6,1.6,0,0,0-.77,1.21v.93a1.37,1.37,0,0,1-.53,1,30.78,30.78,0,0,0-4.21,4.18c-.27.32-.61.48-.84.39l-.65-.27c-.3-.13-.78.15-1.08.62l-2.69,4.24c-.3.48-.3,1,0,1.09l.81.47a.86.86,0,0,1-.07.59,24.06,24.06,0,0,0-1.74,5.22,1.45,1.45,0,0,1-.65.9l-.93.54a1.58,1.58,0,0,0-.77,1.21v3.8c0,.43.34.57.77.33l.93-.54c.31-.18.58-.11.65.15a7.17,7.17,0,0,0,1.74,3.21.79.79,0,0,1-.09.89l-.65,1c-.3.48-.3,1,0,1.09l3.93,2.27,1.12-2.27a3.66,3.66,0,0,0,.17-1.08h0a11.4,11.4,0,0,0,4.21-.69c.31-.11.53,0,.53.35V208c0,.42.35.57.77.32l3.8-2.19a1.59,1.59,0,0,0,.77-1.22V204a1.35,1.35,0,0,1,.53-.95,31.28,31.28,0,0,0,4.21-4.17c.27-.32.61-.49.84-.4l.65.28c.3.13.79-.16,1.09-.63l2.68-4.24c.31-.47.31-1,0-1.09l-.65-.27c-.22-.1-.25-.42-.08-.79a25.31,25.31,0,0,0,1.74-5.21,1.44,1.44,0,0,1,.65-.91l.92-.53a1.59,1.59,0,0,0,.77-1.22v-3.8C261.58,179.66,261.24,179.51,260.81,179.76Zm-7.14,7.76c-.43,4-3.46,8.75-7.21,11.31-4.91,3.37-9.06,1.92-9.06-2.89,0-4.5,3.65-10.27,8.16-12.87C250.39,180.28,254.24,182.25,253.67,187.52Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.82,179.76l-.93.53c-.32.18-.58.11-.66-.15a7.16,7.16,0,0,0-1.73-3.21c-.17-.17-.14-.54.09-.89l.64-1c.31-.47.31-1,0-1.09l-2.68-1.13c-.3-.13-.8.15-1.09.62l-.65,1a1.05,1.05,0,0,1-.83.57,10.86,10.86,0,0,0-2.77.28c-.47.11-1,.25-1.45.42-.3.1-.52,0-.52-.35v-.92A.42.42,0,0,0,248,174a.68.68,0,0,0-.55.09l-3.8,2.2a1.6,1.6,0,0,0-.77,1.21v.93a1.37,1.37,0,0,1-.53,1,30.7,30.7,0,0,0-4.21,4.17c-.27.33-.62.5-.84.4l-.64-.28c-.31-.12-.79.16-1.09.63l-2.69,4.24c-.3.48-.3,1,0,1.09l.81.47a.82.82,0,0,1-.08.59,24.87,24.87,0,0,0-1.73,5.21,1.51,1.51,0,0,1-.65.91l-.93.54a1.59,1.59,0,0,0-.77,1.22v3.79c0,.43.34.57.77.33l.93-.54c.31-.18.57-.11.65.16a7.18,7.18,0,0,0,1.74,3.2.77.77,0,0,1-.09.88l-.65,1c-.3.48-.3,1,0,1.1l3.93,2.26,1.12-2.26a3.52,3.52,0,0,0,.16-1.09h.05a11.4,11.4,0,0,0,4.21-.69c.31-.11.53,0,.53.34V208c0,.42.35.57.77.32l3.8-2.19a1.61,1.61,0,0,0,.78-1.22V204a1.37,1.37,0,0,1,.52-1,30.23,30.23,0,0,0,4.21-4.18c.27-.31.61-.48.83-.39l.66.28c.29.13.79-.16,1.09-.63l2.68-4.24c.31-.47.31-1,0-1.09l-.64-.28c-.23-.09-.26-.41-.1-.78a23.37,23.37,0,0,0,1.74-5.22,1.49,1.49,0,0,1,.66-.9l.93-.53a1.62,1.62,0,0,0,.76-1.22v-3.8C261.58,179.66,261.24,179.51,260.82,179.76Zm-7.15,7.76c-.43,4-3.46,8.75-7.21,11.31-4.91,3.37-9.06,1.92-9.06-2.89,0-4.5,3.65-10.27,8.17-12.88C250.39,180.28,254.24,182.26,253.67,187.52Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.21,181.92l-3.84-2.25-.11,2.25a22.41,22.41,0,0,0,2,1.68c.21,0,1,0,1,0Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.07 208.41 247 210.68 247.17 208.55 245.12 208.26 243.07 208.41",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.81,179.76l-.92.53c-.32.18-.58.11-.65-.15a7.37,7.37,0,0,0-1.74-3.21c-.17-.17-.14-.53.08-.89l.65-1c.31-.48.31-1,0-1.09l-2.68-1.14c-.3-.12-.79.16-1.09.63l-.65,1a1.1,1.1,0,0,1-.84.57,11.4,11.4,0,0,0-4.21.69c-.31.1-.53,0-.53-.35v-.92c0-.43-.34-.57-.77-.33l-3.8,2.2a1.6,1.6,0,0,0-.77,1.21v.93a1.37,1.37,0,0,1-.53,1,30.78,30.78,0,0,0-4.21,4.18c-.27.32-.61.48-.84.39l-.65-.27c-.3-.13-.78.15-1.08.62l-2.69,4.24c-.3.48-.3,1,0,1.09l.81.47a.86.86,0,0,1-.07.59,24.06,24.06,0,0,0-1.74,5.22,1.45,1.45,0,0,1-.65.9l-.93.54a1.58,1.58,0,0,0-.77,1.21v3.8c0,.43.34.57.77.33l.93-.54c.31-.18.58-.11.65.15a7.17,7.17,0,0,0,1.74,3.21.79.79,0,0,1-.09.89l-.65,1c-.3.48-.3,1,0,1.09l3.93,2.27,1.12-2.27a3.66,3.66,0,0,0,.17-1.08h0a11.4,11.4,0,0,0,4.21-.69c.31-.11.53,0,.53.35V208c0,.42.35.57.77.32l3.8-2.19a1.59,1.59,0,0,0,.77-1.22V204a1.35,1.35,0,0,1,.53-.95,31.28,31.28,0,0,0,4.21-4.17c.27-.32.61-.49.84-.4l.65.28c.3.13.79-.16,1.09-.63l2.68-4.24c.31-.47.31-1,0-1.09l-.65-.27c-.22-.1-.25-.42-.08-.79a25.31,25.31,0,0,0,1.74-5.21,1.44,1.44,0,0,1,.65-.91l.92-.53a1.59,1.59,0,0,0,.77-1.22v-3.8C261.58,179.66,261.24,179.51,260.81,179.76Zm-7.14,7.76c-.43,4-3.46,8.75-7.21,11.31-4.91,3.37-9.06,1.92-9.06-2.89,0-4.5,3.65-10.27,8.16-12.87C250.39,180.28,254.24,182.25,253.67,187.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.82,179.76l-.93.53c-.32.18-.58.11-.66-.15a7.16,7.16,0,0,0-1.73-3.21c-.17-.17-.14-.54.09-.89l.64-1c.31-.47.31-1,0-1.09l-2.68-1.13c-.3-.13-.8.15-1.09.62l-.65,1a1.05,1.05,0,0,1-.83.57,10.86,10.86,0,0,0-2.77.28c-.47.11-1,.25-1.45.42-.3.1-.52,0-.52-.35v-.92A.42.42,0,0,0,248,174a.68.68,0,0,0-.55.09l-3.8,2.2a1.6,1.6,0,0,0-.77,1.21v.93a1.37,1.37,0,0,1-.53,1,30.7,30.7,0,0,0-4.21,4.17c-.27.33-.62.5-.84.4l-.64-.28c-.31-.12-.79.16-1.09.63l-2.69,4.24c-.3.48-.3,1,0,1.09l.81.47a.82.82,0,0,1-.08.59,24.87,24.87,0,0,0-1.73,5.21,1.51,1.51,0,0,1-.65.91l-.93.54a1.59,1.59,0,0,0-.77,1.22v3.79c0,.43.34.57.77.33l.93-.54c.31-.18.57-.11.65.16a7.18,7.18,0,0,0,1.74,3.2.77.77,0,0,1-.09.88l-.65,1c-.3.48-.3,1,0,1.1l3.93,2.26,1.12-2.26a3.52,3.52,0,0,0,.16-1.09h.05a11.4,11.4,0,0,0,4.21-.69c.31-.11.53,0,.53.34V208c0,.42.35.57.77.32l3.8-2.19a1.61,1.61,0,0,0,.78-1.22V204a1.37,1.37,0,0,1,.52-1,30.23,30.23,0,0,0,4.21-4.18c.27-.31.61-.48.83-.39l.66.28c.29.13.79-.16,1.09-.63l2.68-4.24c.31-.47.31-1,0-1.09l-.64-.28c-.23-.09-.26-.41-.1-.78a23.37,23.37,0,0,0,1.74-5.22,1.49,1.49,0,0,1,.66-.9l.93-.53a1.62,1.62,0,0,0,.76-1.22v-3.8C261.58,179.66,261.24,179.51,260.82,179.76Zm-7.15,7.76c-.43,4-3.46,8.75-7.21,11.31-4.91,3.37-9.06,1.92-9.06-2.89,0-4.5,3.65-10.27,8.17-12.88C250.39,180.28,254.24,182.26,253.67,187.52Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "243.07 208.41 247 210.68 247.17 208.55 245.12 208.26 243.07 208.41"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M234.24,205l.93-.54c.31-.18.58-.11.65.15a7.17,7.17,0,0,0,1.74,3.21c.17.17.13.54-.09.89l-.65,1c-.3.48-.3,1,0,1.09l2.69,1.14c.3.13.79-.16,1.09-.63l.65-1a1.09,1.09,0,0,1,.83-.57,11.4,11.4,0,0,0,4.21-.69c.31-.11.53,0,.53.35v.92c0,.43.35.58.77.33l3.8-2.19a1.59,1.59,0,0,0,.77-1.22v-.93a1.35,1.35,0,0,1,.53-.95,31.28,31.28,0,0,0,4.21-4.17c.27-.32.62-.49.84-.4l.65.28c.3.12.79-.16,1.09-.63l2.69-4.24c.3-.47.3-1,0-1.09l-.66-.27c-.22-.1-.25-.42-.08-.79a24.61,24.61,0,0,0,1.74-5.22,1.44,1.44,0,0,1,.65-.9l.92-.53a1.61,1.61,0,0,0,.78-1.22v-3.8c0-.43-.35-.57-.78-.33l-.92.54c-.32.18-.58.11-.65-.15a7.27,7.27,0,0,0-1.74-3.21c-.17-.17-.14-.54.09-.89l.65-1c.3-.48.3-1,0-1.09l-2.69-1.14c-.3-.12-.79.16-1.09.63l-.65,1a1.06,1.06,0,0,1-.83.56,11.65,11.65,0,0,0-4.22.7c-.31.1-.53,0-.53-.35v-.92c0-.43-.34-.57-.77-.33l-3.8,2.2a1.6,1.6,0,0,0-.77,1.21v.92a1.37,1.37,0,0,1-.53,1,31.28,31.28,0,0,0-4.21,4.17c-.27.33-.61.49-.83.4l-.65-.28c-.3-.12-.79.16-1.09.63l-2.69,4.24c-.3.48-.3,1,0,1.09l.65.28c.22.09.25.42.09.78a24.06,24.06,0,0,0-1.74,5.22,1.48,1.48,0,0,1-.65.9l-.93.54a1.6,1.6,0,0,0-.77,1.21v3.8C233.47,205.08,233.82,205.22,234.24,205Zm7.09-6.77c0-4.5,3.65-10.27,8.16-12.87,4.83-2.79,8.68-.82,8.11,4.45-.43,4-3.46,8.75-7.21,11.31C245.48,204.46,241.33,203,241.33,198.21Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.47,204.65a.42.42,0,0,0,.17.38l-.76-.44-3.1-1.79-.05,0-.1-.09a.5.5,0,0,1-.09-.31v-3.79a1.44,1.44,0,0,1,.38-.89l3.94,2.26a1.5,1.5,0,0,0-.39.89Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.92,176.29a.64.64,0,0,0-.53.09l-3.8,2.2a1.61,1.61,0,0,0-.53.51l-3.92-2.28a1.76,1.76,0,0,1,.52-.5l3.8-2.2A.68.68,0,0,1,248,174l.09.06,2.11,1.21Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.08,185.84l-.06.07c-.26.28-.57.42-.77.33l-.66-.28-3.92-2.27.64.28c.22.1.57-.07.84-.4Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.48,175.07c-.31-.13-.79.15-1.09.62l-.65,1a1.33,1.33,0,0,1-.21.26.88.88,0,0,1-.6.31h0L253,175a1.05,1.05,0,0,0,.83-.57l.65-1c.29-.47.79-.75,1.09-.62Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.28 173.95 262.17 176.2 259.48 175.06 255.54 172.8 258.28 173.95",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.72,233.14a.86.86,0,0,1-.27,0l-2.17-.92a.64.64,0,0,1-.36-.41,1.2,1.2,0,0,1,.2-1l.53-.83a.48.48,0,0,0,.09-.3,6.09,6.09,0,0,1-1.45-2.64h0l-.75.43a.82.82,0,0,1-.82.06.7.7,0,0,1-.33-.63V223.8a1.62,1.62,0,0,1,.8-1.29l.75-.43a.81.81,0,0,0,.35-.5,20.38,20.38,0,0,1,1.43-4.29.9.9,0,0,0,.06-.18l-.47-.2a.64.64,0,0,1-.36-.41,1.2,1.2,0,0,1,.2-1l2.17-3.42a1.17,1.17,0,0,1,1.32-.65l.53.22a.87.87,0,0,0,.26-.22,25.31,25.31,0,0,1,3.45-3.42.76.76,0,0,0,.3-.5v-.74a1.62,1.62,0,0,1,.8-1.29l3.07-1.78a.86.86,0,0,1,.83-.05.7.7,0,0,1,.33.63V205a9.62,9.62,0,0,1,3.49-.56c.06,0,.22-.08.36-.3l.52-.83a1.18,1.18,0,0,1,1.32-.64l2.17.92a.63.63,0,0,1,.37.41,1.23,1.23,0,0,1-.21,1l-.52.82a.49.49,0,0,0-.1.31,6,6,0,0,1,1.46,2.64h0l.75-.43a.81.81,0,0,1,.83-.06.7.7,0,0,1,.33.63v3.07a1.65,1.65,0,0,1-.8,1.29l-.75.43a.85.85,0,0,0-.36.49,19.72,19.72,0,0,1-1.43,4.3.56.56,0,0,0,0,.22l.46.16a.63.63,0,0,1,.37.41,1.23,1.23,0,0,1-.21,1L224,223.63a1.19,1.19,0,0,1-1.32.65l-.52-.22a.84.84,0,0,0-.27.21,24.21,24.21,0,0,1-3.45,3.42.78.78,0,0,0-.29.5v.75a1.65,1.65,0,0,1-.8,1.29L214.31,232a.84.84,0,0,1-.83.06.7.7,0,0,1-.33-.63v-.67a9.65,9.65,0,0,1-3.49.56h0a.62.62,0,0,0-.36.29l-.53.83A1.33,1.33,0,0,1,207.72,233.14Zm-3.37-6.88a.7.7,0,0,1,.25.05.64.64,0,0,1,.36.42,5.42,5.42,0,0,0,1.31,2.44.93.93,0,0,1,0,1.15l-.53.83a.56.56,0,0,0-.12.4l2.13.88c.07,0,.27-.09.44-.37l.53-.83a1.14,1.14,0,0,1,1-.62,8.84,8.84,0,0,0,3.27-.55.68.68,0,0,1,.64.07.65.65,0,0,1,.26.55v.75l.09,0,3.07-1.78a.91.91,0,0,0,.45-.67v-.75a1.46,1.46,0,0,1,.55-1.05,24.47,24.47,0,0,0,3.36-3.32,1,1,0,0,1,1.08-.42l.53.22c.06,0,.27-.09.44-.37l2.17-3.42a.6.6,0,0,0,.13-.4l-.49-.19a.57.57,0,0,1-.32-.34,1,1,0,0,1,.06-.77,19.58,19.58,0,0,0,1.39-4.14,1.52,1.52,0,0,1,.69-1l.75-.43a.91.91,0,0,0,.45-.67v-3.07l-.09,0-.75.43a.79.79,0,0,1-.69.09.63.63,0,0,1-.36-.42,5.44,5.44,0,0,0-1.32-2.44,1,1,0,0,1,0-1.16l.52-.82a.6.6,0,0,0,.13-.4l-2.14-.89h0a.82.82,0,0,0-.44.38l-.52.82a1.22,1.22,0,0,1-1,.63h0a9.08,9.08,0,0,0-3.28.54.66.66,0,0,1-.63-.07.64.64,0,0,1-.26-.55v-.74l-.09,0-3.07,1.77a1,1,0,0,0-.45.68v.74a1.44,1.44,0,0,1-.56,1A24.49,24.49,0,0,0,210,211.9a1,1,0,0,1-1.09.42l-.53-.22a.79.79,0,0,0-.44.37l-2.17,3.42a.56.56,0,0,0-.12.4l.48.19a.58.58,0,0,1,.33.34,1,1,0,0,1-.07.77,19.35,19.35,0,0,0-1.38,4.14,1.52,1.52,0,0,1-.7,1l-.75.44a.93.93,0,0,0-.44.67v3.07l.09,0,.75-.44A1,1,0,0,1,204.35,226.26Zm8-.42a3.8,3.8,0,0,1-1.76-.41,4,4,0,0,1-1.9-3.76c0-3.75,3-8.56,6.78-10.72,2.11-1.22,4.11-1.41,5.49-.51s1.81,2.4,1.59,4.46a14.48,14.48,0,0,1-6,9.39A7.74,7.74,0,0,1,212.37,225.84ZM219,210.59a6.39,6.39,0,0,0-3.12,1c-3.54,2-6.42,6.57-6.42,10.1a3.3,3.3,0,0,0,1.52,3.13c1.29.68,3.25.27,5.25-1.09a13.76,13.76,0,0,0,5.67-8.89c.19-1.78-.26-3.12-1.27-3.78A2.93,2.93,0,0,0,219,210.59Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.19,292.55a5.68,5.68,0,0,1-2.83-.77,5.6,5.6,0,0,1-2.82-4.89,10.9,10.9,0,0,1,5.44-9.41l114.41-65.85a5.65,5.65,0,0,1,8.47,4.89,10.87,10.87,0,0,1-5.45,9.41L176,291.79A5.64,5.64,0,0,1,173.19,292.55Zm117-80.61a4.6,4.6,0,0,0-2.29.61L173.51,278.41a9.81,9.81,0,0,0-4.9,8.48,4.58,4.58,0,0,0,6.86,4L289.88,225a9.81,9.81,0,0,0,4.91-8.49,4.6,4.6,0,0,0-4.58-4.58Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.11,238.94v10.18l-69.36,39.93a3.52,3.52,0,0,1-5.27-3.05,7.08,7.08,0,0,1,3.56-6.15Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.84,252.06c-.65-.29-1-1.07-1-2.32v-5l1.26-.72V249c0,1.89.82,2.35,2.47,1.4a5,5,0,0,0,1.84-1.76,4.75,4.75,0,0,0,.64-2.5v-4.95l1.22-.7v5a6.36,6.36,0,0,1-1,3.46,7.6,7.6,0,0,1-2.73,2.57C208.41,252.16,207.49,252.35,206.84,252.06Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,236.25c.65.17,1,.73,1,1.68a4.87,4.87,0,0,1-1,2.82,8.3,8.3,0,0,1-2.69,2.36l-2.17,1.26V247l-1.26.72V239l3.43-2A3.91,3.91,0,0,1,222,236.25Zm-.91,4.23a3,3,0,0,0,.63-1.82c0-.64-.21-1-.63-1.1a2.78,2.78,0,0,0-1.82.54l-2.13,1.23v3.94l2.13-1.23A5.59,5.59,0,0,0,221.07,240.48Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.8,233.81l3.7-2.14a5.91,5.91,0,0,1,2.48-.88,2,2,0,0,1,1.67.59,2.77,2.77,0,0,1,.6,1.94,6.47,6.47,0,0,1-.6,2.64,9.77,9.77,0,0,1-1.67,2.52,10.6,10.6,0,0,1-2.48,2l-3.7,2.13Zm3.63,5.6a7.81,7.81,0,0,0,1.87-1.5,6.92,6.92,0,0,0,1.25-1.88,4.8,4.8,0,0,0,.44-2,2.1,2.1,0,0,0-.44-1.47,1.43,1.43,0,0,0-1.25-.44,4.35,4.35,0,0,0-1.87.66l-2.37,1.37v6.61Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.64,231.25,236,234l-1,2.75-1.29.75,4-11.09,1.24-.71,4,6.48-1.31.76Zm-.44-.75-1.89-3.21-1.9,5.4Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.53,222.93l-3,1.74v-1.1l7.27-4.19v1.09l-3,1.74v7.69l-1.25.72Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.53,222.6v1.09l-6.37,3.69v-8.79l6.2-3.58v1.09l-5,2.86v2.69l4.41-2.54v1.07l-4.41,2.54v2.84Z",
    style: {
      fill: "#FB8CFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floder--inject-110"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "331.24 85.63 372.62 61.44 374.09 62.33 332.48 86.4 331.42 85.72",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "318.49 89.56 318.49 139.57 318.66 140.94 324.86 139.04 374.09 111.77 374.09 62.33 332.48 86.4 330.93 82.47 318.49 89.56",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "318.49 89.56 318.49 139.57 318.66 140.94 324.86 139.04 374.09 111.77 374.09 62.33 332.48 86.4 330.93 82.47 318.49 89.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.35,56.89a.51.51,0,0,0-.78-.44L335.74,80.21a2.17,2.17,0,0,0-1.05,1.85v36.06a.66.66,0,0,0,.82.63,1.91,1.91,0,0,1-1.64,0,1.45,1.45,0,0,1-.73-1.27v-36a2.23,2.23,0,0,1,.43-1.3,2.17,2.17,0,0,1,.62-.55L375,55.8a1.34,1.34,0,0,1,1.36,0C377.21,56.28,377.35,56.56,377.35,56.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.35,56.89a.51.51,0,0,0-.78-.44L335.74,80.21a2,2,0,0,0-.82.9l-1.35-1a2.17,2.17,0,0,1,.62-.55L375,55.8a1.34,1.34,0,0,1,1.36,0C377.21,56.28,377.35,56.56,377.35,56.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.05,95.17l-40.39,23.51a.65.65,0,0,1-1-.57v-36a2.14,2.14,0,0,1,1.06-1.84l40.84-23.77a.51.51,0,0,1,.77.44v36A2.63,2.63,0,0,1,376.05,95.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,100.29l53.86-31.17-9.47,42.65-53.85,31.17a2.08,2.08,0,0,1-1.42.17s.05,0,.6-1.56S329.7,100.29,329.7,100.29Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.24 68.47 383.56 69.12 329.7 100.29 328.38 99.64 382.24 68.47",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "317.43 88.89 329.8 81.7 330.93 82.47 318.49 89.56 317.43 88.89",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "332 85.19 372.62 61.44 374.09 62.33 332.48 86.4 332 85.19",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.24 68.47 383.56 69.12 329.7 100.29 328.38 99.64 382.24 68.47",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "317.43 88.89 329.8 81.7 330.93 82.47 318.49 89.56 317.43 88.89",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,88.89v52a3.07,3.07,0,0,0,.75,1.93,1.06,1.06,0,0,0,1.78-.39l9.74-42.1-1.32-.65-9,40.16a.42.42,0,0,1-.5.26.52.52,0,0,1-.35-.49v-50Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.43,88.89v52a3.07,3.07,0,0,0,.75,1.93,1.06,1.06,0,0,0,1.78-.39l9.74-42.1-1.32-.65-9,40.16a.42.42,0,0,1-.5.26.52.52,0,0,1-.35-.49v-50Z",
    style: {
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.89,248.2l-3.46.77V294.8a2.88,2.88,0,0,1-1.44,2.5L70.32,336v4.67a3.92,3.92,0,0,1-3.55-.16A2.89,2.89,0,0,1,65.36,338V287.37a2.87,2.87,0,0,1,1.45-2.5l69.74-40.47.12-.06h0a3.92,3.92,0,0,1,5.22,3.86Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,248.2l-3.46.77V294.8a2.88,2.88,0,0,1-1.44,2.5L70.32,336v4.67a3.92,3.92,0,0,1-3.55-.16A2.89,2.89,0,0,1,65.36,338V287.37a2.87,2.87,0,0,1,1.45-2.5l69.74-40.47.12-.06h0a3.92,3.92,0,0,1,5.22,3.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,248.2l-3.46.77v1.84L70.51,289l-4.92-2.76a3,3,0,0,1,1.22-1.37l69.74-40.47.12-.06h0a3.92,3.92,0,0,1,5.22,3.86Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.89,248.2l-3.46.77v1.84L70.51,289l-4.92-2.76a3,3,0,0,1,1.22-1.37l69.74-40.47.12-.06h0a3.92,3.92,0,0,1,5.22,3.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.27,287.59,140,247.11a1.26,1.26,0,0,1,1.88,1.09v49.31a2.9,2.9,0,0,1-1.44,2.51L70.71,340.49a1.25,1.25,0,0,1-1.88-1.09V290.09A2.9,2.9,0,0,1,70.27,287.59Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.18,270.78l-2.32,3.66c-3.26-1.92-8.1-1.54-13.5,1.58-8.47,4.89-15.56,14.9-17.35,23.86-.14.72.36,1,1,.66l2.43-1.41a2.21,2.21,0,0,0,1-1.31,29.22,29.22,0,0,1,12.92-17.39c4.19-2.41,7.92-2.64,10.37-1l-3,4.76c-.62,1-.24,1.8.62,1.39l8.08-3.86a2.87,2.87,0,0,0,1.53-2.26V270.5C122.94,269.58,121.83,269.76,121.18,270.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.36,307.17c-4.19,2.42-7.92,2.64-10.37,1.05l3-4.77c.61-1,.24-1.8-.62-1.39l-8.08,3.86a2.87,2.87,0,0,0-1.53,2.26v8.93c0,.91,1.11.73,1.76-.29l2.31-3.65c3.27,1.92,8.1,1.54,13.51-1.58,8.47-4.89,15.56-14.91,17.34-23.87.15-.71-.35-1-1-.65l-2.43,1.4a2.24,2.24,0,0,0-1,1.31A29.26,29.26,0,0,1,105.36,307.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-110"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "323.81 183.81 327.77 189.13 332.36 191.64 331.2 179.57 323.81 183.81",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.81 183.81 327.77 189.13 332.36 191.64 331.2 179.57 323.81 183.81",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.41 186.32 332.36 191.64 335.8 182.08 328.41 186.32",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,121.35l-3.46.77v20.13a2.9,2.9,0,0,1-1.44,2.5l-70.27,40.77v4.67a4,4,0,0,1-3.55-.15,2.91,2.91,0,0,1-1.41-2.52V162.59a2.85,2.85,0,0,1,.23-1.13,2.9,2.9,0,0,1,1.22-1.37l73.34-42.55a.61.61,0,0,1,.12-.05h0a3.92,3.92,0,0,1,5.22,3.87Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,121.35l-3.46.77v20.13a2.9,2.9,0,0,1-1.44,2.5l-70.27,40.77v4.67a4,4,0,0,1-3.55-.15,2.91,2.91,0,0,1-1.41-2.52V162.59a2.85,2.85,0,0,1,.23-1.13,2.9,2.9,0,0,1,1.22-1.37l73.34-42.55a.61.61,0,0,1,.12-.05h0a3.92,3.92,0,0,1,5.22,3.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,121.35l-3.46.77V124l-71.52,40.27-4.92-2.76a2.9,2.9,0,0,1,1.22-1.37l73.34-42.55a.61.61,0,0,1,.12-.05h0a3.92,3.92,0,0,1,5.22,3.87Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,121.35l-3.46.77V124l-71.52,40.27-4.92-2.76a2.9,2.9,0,0,1,1.22-1.37l73.34-42.55a.61.61,0,0,1,.12-.05h0a3.92,3.92,0,0,1,5.22,3.87Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.59,162.8l73.34-42.55a1.26,1.26,0,0,1,1.88,1.09V145a2.9,2.9,0,0,1-1.44,2.5L323,190a1.26,1.26,0,0,1-1.89-1.09V165.31A2.89,2.89,0,0,1,322.59,162.8Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,167.2a.77.77,0,0,1-.39-1.44l66.89-38.53a.77.77,0,0,1,1,.28.78.78,0,0,1-.28,1L326.42,167.1A.75.75,0,0,1,326,167.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,172.52a.77.77,0,0,1-.39-1.44l66.89-38.54a.77.77,0,0,1,1,.29.78.78,0,0,1-.28,1l-66.89,38.53A.76.76,0,0,1,326,172.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,177.83a.77.77,0,0,1-.39-1.44l57.66-33.22a.77.77,0,0,1,.77,1.34l-57.66,33.22A.75.75,0,0,1,326,177.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,183.15a.77.77,0,0,1-.39-1.44l66.89-38.54a.77.77,0,0,1,1,.29.78.78,0,0,1-.28,1L326.42,183A.76.76,0,0,1,326,183.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,248.47l1.31-4.15-5.33,3,2.5,4.18a.38.38,0,0,0,.11.11h0l3.23,1.79v-6.26Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,248.47l1.31-4.15-5.33,3,2.5,4.18a.38.38,0,0,0,.11.11h0l3.23,1.79v-6.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,218.73l-4.32,1.65v16a4,4,0,0,1-2,3.51l-14.42,8.28v5.07c-1.53.65-3.37-.49-3.37-.49-2.23-1.23-2.09-2.76-2.09-2.76V229.11a3.28,3.28,0,0,1,.37-1.52A3.33,3.33,0,0,1,79,226.2l18.87-10.84a3.33,3.33,0,0,1,2.65-.19C102,215.63,103.58,216.89,103.58,218.73Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,218.73l-4.32,1.65v16a4,4,0,0,1-2,3.51l-14.42,8.28v5.07c-1.53.65-3.37-.49-3.37-.49-2.23-1.23-2.09-2.76-2.09-2.76V229.11a3.28,3.28,0,0,1,.37-1.52A3.33,3.33,0,0,1,79,226.2l18.87-10.84a3.33,3.33,0,0,1,2.65-.19C102,215.63,103.58,216.89,103.58,218.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,218.73l-4.32,1.65v1.85l-16.83,8.26-4.71-2.9A3.33,3.33,0,0,1,79,226.2l18.87-10.84a3.33,3.33,0,0,1,2.65-.19C102,215.63,103.58,216.89,103.58,218.73Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,218.73l-4.32,1.65v1.85l-16.83,8.26-4.71-2.9A3.33,3.33,0,0,1,79,226.2l18.87-10.84a3.33,3.33,0,0,1,2.65-.19C102,215.63,103.58,216.89,103.58,218.73Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.58,218.73V239a4.07,4.07,0,0,1-2,3.52L82.81,253.25a.77.77,0,0,1-1.15-.66V231.7a3.37,3.37,0,0,1,1.69-2.91L102.23,218A.9.9,0,0,1,103.58,218.73Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,249.12l2.5,4.18a.31.31,0,0,0,.56-.07l2.27-7.14Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,233c0,.95.78,1.28,1.73.73a3.58,3.58,0,0,0,1.73-2.73c0-1-.77-1.29-1.73-.73A3.59,3.59,0,0,0,96.9,233Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.68,236.59c0,.95.78,1.28,1.73.73a3.58,3.58,0,0,0,1.73-2.73c0-1-.77-1.29-1.73-.73A3.59,3.59,0,0,0,90.68,236.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.46,240.18c0,.95.78,1.28,1.73.73a3.58,3.58,0,0,0,1.73-2.73c0-1-.77-1.28-1.73-.73A3.59,3.59,0,0,0,84.46,240.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Suitcase--inject-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.08,391.16l-6.41,3.69a1,1,0,0,1-1,0L344.4,373.33a.3.3,0,0,1,0-.52l6.41-3.68a1,1,0,0,1,1,0l37.28,21.51A.3.3,0,0,1,389.08,391.16Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.22,353.51v30.92a3.15,3.15,0,0,1-1.4,2.51,16.8,16.8,0,0,1-3.38,1.79,9.57,9.57,0,0,1-3.46.7l1.15-31.78,1.55-2.46Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,357.65v30.54a1.22,1.22,0,0,1-1.33,1.23,4.56,4.56,0,0,1-1.63-.62l-32.24-18.61a6,6,0,0,1-2.68-5V335.73l6.74,1.84L378.22,354Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.13,357.65v30.54a1.22,1.22,0,0,1-1.33,1.23,4.56,4.56,0,0,1-1.63-.62l-32.24-18.61a6,6,0,0,1-2.68-5V335.73l6.74,1.84L378.22,354Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25,347.6s-.21,2.29,3,4.09c3,1.68,28.77,16.51,32.3,18.54a1.66,1.66,0,0,0,1.5.11c.55-.25,1.1-.88,1.1-2.41v-11l-36.72-21.44-1.16.24Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.25,347.6s-.21,2.29,3,4.09c3,1.68,28.77,16.51,32.3,18.54a1.66,1.66,0,0,0,1.5.11c.55-.25,1.1-.88,1.1-2.41v-11l-36.72-21.44-1.16.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08,353.83l-6.41,3.69a1,1,0,0,1-1,0L344.4,336a.3.3,0,0,1,0-.52l6.41-3.69a1,1,0,0,1,1,0l37.28,21.52A.3.3,0,0,1,389.08,353.83Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08,353.83l-6.41,3.69a1,1,0,0,1-1,0L344.4,336a.3.3,0,0,1,0-.52l6.41-3.69a1,1,0,0,1,1,0l37.28,21.52A.3.3,0,0,1,389.08,353.83Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,357.13v2.28a1.46,1.46,0,0,0,.74,1.27l6.24,3.58a.52.52,0,0,0,.78-.45v-2.28a1.45,1.45,0,0,0-.74-1.27l-6.23-3.58A.53.53,0,0,0,359,357.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.87,332.84a3.48,3.48,0,0,0-1.76,1l1.76,2.81v3.93l1.16.67v-5l10.11,5.86.72,7.34,1.76-1v-7.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.03 336.05 360.27 335.73 360.27 342.25 362.03 341.25 362.03 336.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.11,333.84v7.74a2.77,2.77,0,0,0,1.16.67v-6.52l11.44,6.56v6.51a1.94,1.94,0,0,0,1.15.67v-7.74Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-110"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345,391.69s.36.08.43,1.18a35.38,35.38,0,0,1,0,5.05c-.15.77-1.83,1.9-3.9,1.67s-3.5-1.83-4.53-3.4-5.53-7-6.36-8.28-2.09-4.76-.5-6.19c1.35-1.2,6.37,1.53,7.71,3S345,391.69,345,391.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62,407.18a6.44,6.44,0,0,1,1,2.52,32.63,32.63,0,0,1,0,6.37,3.34,3.34,0,0,1-2.94,1.47c-1.05.06-2.53.11-3.55.15a5,5,0,0,0-2.18.56,59.93,59.93,0,0,1-5.66,2.56,14,14,0,0,1-8.13.74,10.44,10.44,0,0,1-5.63-3.11,2.05,2.05,0,0,1-.14-2.12c.34-.44,5.44-2.54,8-3.83s10.18-4.35,10.84-4.87S323.62,407.18,323.62,407.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.63,219.78a4.19,4.19,0,0,0,.48-2c0-2,0-4.6,0-5.33.22-3.44,1.25-4.8,1.25-4.8,4.21-5.49,19.6-4.26,20.69-1.17s3.24,20-1.51,23c.49,2.64,1.86,9.07,1.86,9.07-3.85,3.49-11.88,2.37-11.88,2.37.24-1.17-.84-5.87-1.42-8.27-3.3.4-6.15.35-7.08-.34h0a1.14,1.14,0,0,1-.19-.19c-.71-1-1.19-3.3-1.47-7.95-.87.11-2.14-.2-2.31-.54S307.84,221.27,308.63,219.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.35,269.8,304.87,233a2.75,2.75,0,0,0-1.33-1.49l.3-.4-1.79.08h0a2.8,2.8,0,0,0-1.17.36l-20.51,11.85a2.76,2.76,0,0,0-1.22,3.35l13.48,36.81a2.76,2.76,0,0,0,2.31,1.8h0l1.56.09-.25-.27a2.59,2.59,0,0,0,.38-.17l20.51-11.84A2.78,2.78,0,0,0,318.35,269.8Z",
    style: {
      fill: "#374d56"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.61,246.62l13.59,37.11a2.62,2.62,0,0,0,3.77,1.36l20.78-12a2.61,2.61,0,0,0,1.15-3.16l-13.6-37.11a2.61,2.61,0,0,0-3.76-1.37l-20.79,12A2.62,2.62,0,0,0,280.61,246.62Z",
    style: {
      fill: "#556f77"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.48,246.37l12.7,34.68a1.2,1.2,0,0,0,1.72.62L317.09,270a1.2,1.2,0,0,0,.52-1.45L304.9,233.89a1.19,1.19,0,0,0-1.71-.62L283,244.92A1.2,1.2,0,0,0,282.48,246.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.83,261.41l-.05,0-.46-.26a.32.32,0,0,1-.1-.1.25.25,0,0,1-.05-.18l0-.14a.35.35,0,0,0,0-.06,2.76,2.76,0,0,1-.49-.57h0l-.1.06s-.08,0-.14,0a.47.47,0,0,1-.11-.13l-.27-.6c0-.09,0-.19,0-.22l.1,0s0-.05,0-.09a4.27,4.27,0,0,1-.13-.77v0l-.1-.05a.47.47,0,0,1-.1-.1.26.26,0,0,1-.05-.18l.07-.58c0-.1.08-.13.17-.08l.11.07,0,0a1.53,1.53,0,0,1,.3-.53.06.06,0,0,0,0-.08l-.06-.15a.19.19,0,0,1,0-.22l.38-.22a.15.15,0,0,1,.14,0,.36.36,0,0,1,.11.14l.06.13a1.34,1.34,0,0,1,.56,0s0,0,0,0v-.14c0-.09.09-.12.18-.07l.46.27a.41.41,0,0,1,.1.09.26.26,0,0,1,.05.18l0,.14a.35.35,0,0,0,0,.06,3.05,3.05,0,0,1,.49.57h0l.09-.05a.12.12,0,0,1,.14,0,.33.33,0,0,1,.12.14l.27.59c0,.1,0,.19,0,.22l-.09.06s0,0,0,.08a3.56,3.56,0,0,1,.14.78s0,0,0,0l.09.05a.28.28,0,0,1,.1.09.27.27,0,0,1,0,.19l-.07.58c0,.09-.09.12-.17.07l-.12-.07a.11.11,0,0,0,0,0,1.48,1.48,0,0,1-.3.52.09.09,0,0,0,0,.09l.07.14c0,.09,0,.19,0,.22l-.37.22a.15.15,0,0,1-.14,0,.26.26,0,0,1-.11-.14l-.06-.13a1.33,1.33,0,0,1-.56,0h0s0,0,0,0l0,.14C297.94,261.39,297.9,261.42,297.83,261.41Zm-1.19-1.48,0,0a.19.19,0,0,1,.1.1,2.91,2.91,0,0,0,.45.52.34.34,0,0,1,.1.23l0,.14s0,.06,0,.07l.45.26s0,0,0-.06l0-.14A.09.09,0,0,1,298,261a1.15,1.15,0,0,0,.52,0,.15.15,0,0,1,.12,0,.27.27,0,0,1,.09.12l.07.14h0l.38-.22s0-.08,0-.12l-.07-.14a.21.21,0,0,1,0-.19,1.34,1.34,0,0,0,.29-.51.09.09,0,0,1,.15,0l.12.06s0,0,0-.05l.07-.58s0-.07,0-.07l-.1-.06-.09-.08a.3.3,0,0,1-.05-.15,4.07,4.07,0,0,0-.13-.75.14.14,0,0,1,0-.16l.1,0a.09.09,0,0,0,0-.11l-.27-.6h0l-.09.06a.12.12,0,0,1-.11,0,.22.22,0,0,1-.1-.09,3,3,0,0,0-.45-.53.27.27,0,0,1-.1-.22l0-.14a.15.15,0,0,0,0-.08l-.45-.26h0s0,0-.05.06v.14a.09.09,0,0,1-.12.08h0a1.16,1.16,0,0,0-.52,0,.12.12,0,0,1-.12,0,.52.52,0,0,1-.1-.11l-.06-.15h0l-.38.22a.09.09,0,0,0,0,.11l.07.15a.17.17,0,0,1,0,.18,1.58,1.58,0,0,0-.29.51c0,.06-.08.08-.15,0l-.11-.07s0,0,0,.06L296,258a.13.13,0,0,0,0,.08l.1,0,.09.08a.3.3,0,0,1,0,.15,3.28,3.28,0,0,0,.13.75.14.14,0,0,1,0,.16l-.09,0s0,.08,0,.12l.28.6h0l.09-.05A.08.08,0,0,1,296.64,259.93Zm1.35.24a.91.91,0,0,1-.34-.15,1.8,1.8,0,0,1-.66-.81,1.44,1.44,0,0,1,.23-1.81.83.83,0,0,1,.91.12,2,2,0,0,1,.67.93,1.48,1.48,0,0,1-.21,1.59A.68.68,0,0,1,298,260.17Zm-.2-2.7a.61.61,0,0,0-.46.06,1.38,1.38,0,0,0-.22,1.71,1.6,1.6,0,0,0,.54.67.66.66,0,0,0,.82,0,1.39,1.39,0,0,0,.2-1.5,1.69,1.69,0,0,0-.56-.79A.93.93,0,0,0,297.79,257.47Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,257l.11-.07a.1.1,0,0,1,.13.06,4,4,0,0,0,.59.69.21.21,0,0,1,.06.17l0,.17a.23.23,0,0,0,.1.22l.57.33c.06,0,.12,0,.13-.08l0-.18c0-.06.05-.09.1-.07a1.52,1.52,0,0,0,.67,0s.09,0,.12.09l.08.18c0,.09.11.13.17.1l.46-.28c.06,0,.07-.12,0-.2l-.08-.18a.17.17,0,0,1,0-.17,1.83,1.83,0,0,0,.37-.64.07.07,0,0,1,.11,0l.14.08c.06,0,.12,0,.13-.08l.09-.72a.22.22,0,0,0-.1-.21l-.13-.08a.21.21,0,0,1-.09-.15,4,4,0,0,0-.16-.95.12.12,0,0,1,0-.15l.11-.07c.05,0,.06-.12,0-.2l-.34-.74c0-.09-.11-.13-.16-.1l-.12.07s-.09,0-.12-.06a3.68,3.68,0,0,0-.59-.69.22.22,0,0,1-.07-.17l0-.17a.26.26,0,0,0-.1-.22l-.57-.33c-.06,0-.12,0-.13.08l0,.17c0,.06-.05.09-.1.08a1.53,1.53,0,0,0-.67,0,.13.13,0,0,1-.12-.09l-.09-.18c0-.09-.11-.13-.16-.1l-.47.28c-.05,0-.06.12,0,.2l.08.18a.17.17,0,0,1,0,.17,2,2,0,0,0-.36.64.07.07,0,0,1-.11,0l-.14-.08c-.06,0-.12,0-.13.08l-.1.72a.24.24,0,0,0,.1.21l.14.08a.16.16,0,0,1,.08.15,4.6,4.6,0,0,0,.16,1c0,.06,0,.13,0,.15l-.11.07c-.06,0-.07.12,0,.2l.34.74C299.83,257,299.9,257,300,257Zm.64-1c-.4-.88-.28-1.86.27-2.18s1.44.19,1.81,1.19a1.79,1.79,0,0,1-.25,1.92C301.86,257.35,301,256.9,300.59,256Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.27,253l.16-.09c.05,0,.12,0,.17.07a5.08,5.08,0,0,0,.8,1,.3.3,0,0,1,.09.24l0,.23a.34.34,0,0,0,.13.29l.78.45c.09.06.17,0,.18-.1l0-.24a.11.11,0,0,1,.13-.11,1.92,1.92,0,0,0,.92.05c.06,0,.13,0,.17.13l.11.24c0,.12.15.17.22.13l.64-.37a.23.23,0,0,0,0-.28l-.11-.25a.21.21,0,0,1,0-.23,2.63,2.63,0,0,0,.49-.87c0-.07.09-.1.15-.06l.19.11c.09.05.17,0,.19-.11l.12-1a.29.29,0,0,0-.13-.29l-.19-.11a.28.28,0,0,1-.12-.21,5.88,5.88,0,0,0-.21-1.29.18.18,0,0,1,0-.21l.16-.09c.07,0,.08-.17,0-.28l-.46-1c-.05-.12-.15-.17-.22-.13l-.16.09s-.12,0-.17-.08a4.73,4.73,0,0,0-.8-1,.28.28,0,0,1-.09-.23l0-.24a.31.31,0,0,0-.13-.29l-.78-.45c-.09-.05-.17,0-.18.11l0,.24c0,.08-.07.12-.13.1a2.21,2.21,0,0,0-.92,0,.18.18,0,0,1-.17-.12l-.11-.25c-.05-.11-.15-.17-.22-.13l-.64.38a.23.23,0,0,0,0,.28l.11.25a.19.19,0,0,1,0,.22,2.68,2.68,0,0,0-.49.88.1.1,0,0,1-.15.06l-.19-.11c-.09,0-.17,0-.18.11l-.13,1a.34.34,0,0,0,.13.29l.19.11a.32.32,0,0,1,.12.22,5.45,5.45,0,0,0,.22,1.29.21.21,0,0,1-.05.21l-.16.09c-.07,0-.08.16,0,.28l.46,1C292.1,253,292.2,253,292.27,253Zm.87-1.41c-.55-1.2-.38-2.53.38-3s2,.27,2.47,1.64a2.41,2.41,0,0,1-.34,2.61C294.88,253.49,293.72,252.87,293.14,251.59Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.09,271.58a1.67,1.67,0,0,1-.56-.27,2.84,2.84,0,0,1-.93-1.06c-.34-.76-.3-1.38.12-1.62l14.07-8.18c.22-.13.59,0,1,.23a2.68,2.68,0,0,1,.92,1.07c.35.75.3,1.37-.11,1.61l-14.08,8.18A.53.53,0,0,1,297.09,271.58Zm13.22-11a.48.48,0,0,0-.34,0l-14.08,8.19c-.37.21-.41.77-.1,1.45a2.2,2.2,0,0,0,.75.86c.32.22.62.29.8.19l14.08-8.18c.37-.22.41-.78.1-1.46a2.27,2.27,0,0,0-.75-.86A1.37,1.37,0,0,0,310.31,260.62Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.86,264.05l.9,2-8.54,5c-.28.17-.94-.28-1.18-.81a1.34,1.34,0,0,1-.15-.65.47.47,0,0,1,.22-.4Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.59,265.66a1.19,1.19,0,0,1-.38-.49l-.44-1,.15-.09.44,1c.17.36.36.49.56.37a.32.32,0,0,0,.16-.27.92.92,0,0,0-.11-.46l-.44-1,.15-.09.45,1a1.26,1.26,0,0,1,.13.64.51.51,0,0,1-.24.39A.42.42,0,0,1,298.59,265.66Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.82,263.19a.67.67,0,0,1,.32.37.81.81,0,0,1,.08.51.51.51,0,0,1-.26.35l-.26.16.23.52-.15.09-.78-1.72.42-.24A.42.42,0,0,1,299.82,263.19Zm.22.79a.5.5,0,0,0-.05-.33.51.51,0,0,0-.21-.24.33.33,0,0,0-.27,0l-.26.16.35.76.26-.15A.34.34,0,0,0,300,264Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.1,262.83l.45-.26a.51.51,0,0,1,.36-.07.67.67,0,0,1,.34.18,1.24,1.24,0,0,1,.28.4,1.55,1.55,0,0,1,.13.49.93.93,0,0,1-.07.42.66.66,0,0,1-.26.29l-.45.26Zm1.13,1.24a.46.46,0,0,0,.19-.22.62.62,0,0,0,.05-.31,1.08,1.08,0,0,0-.1-.37.88.88,0,0,0-.21-.3.43.43,0,0,0-.25-.14.38.38,0,0,0-.27,0l-.29.17.59,1.29Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.63,263l-.57.33.07.5-.16.09-.29-2,.16-.08,1.27,1.42-.17.09Zm-.14-.17-.62-.7.15,1Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.74,261.55l-.37.22-.09-.21.89-.52.1.21-.37.21.68,1.5-.15.09Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.8,262l.1.21-.78.46-.78-1.71.76-.45.1.21-.61.36.24.52.54-.31.09.21-.54.31.25.56Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.05,232.23c.93.69,3.78.74,7.08.34a5.6,5.6,0,0,0,1.77-1.77C319.62,230.92,314.37,233.19,311.05,232.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.62,402.23v4.95a4.93,4.93,0,0,1-5.78,2.46,4.11,4.11,0,0,1-2.57-2s-.16-3.95-.3-5.39",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,388.71v3a3.58,3.58,0,0,1-3.53,1.48,4.39,4.39,0,0,1-3.34-1.68l-.07-3.23",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.25,259.47l-11.64,3.09.93,3.8-1.35-.78-4.69,7.56,8.84,4.69s3.6,2.41,6.06,2.36A6.22,6.22,0,0,0,356,274.6C356.5,270.81,352.25,259.47,352.25,259.47Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,266.52s1.87,6,2.89,7.46a39,39,0,0,1-4.27-7.93",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,297s.48,49.75.89,55.72,7.21,50.73,7.21,50.73c5.45,2.56,9.05,0,9.05,0a23.69,23.69,0,0,1,0-4.23c.2-2.57,2.16-25.61,2-33.84a39.19,39.19,0,0,0-2.68-13.79L326,311.79l1.37-.62s.29,5.62.66,12.21v.05c.45,7.68,1,16.66,1.38,19.72.69,5.69,4.88,26.47,6.11,31.34S338,388.56,338,388.56c2.41,2.39,7.23.54,7.23.54s0-6.1.32-9.87,1.82-20.6,1.24-25-3-12.27-3.22-13.85,1.14-36.84,1.14-36.84a23.28,23.28,0,0,0,.3-11.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,238.13a19.52,19.52,0,0,1,9.28,8.51,114.9,114.9,0,0,1,6,14.31s-5.91,5.57-13.55,5.88Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,238.13a19.52,19.52,0,0,1,9.28,8.51,114.9,114.9,0,0,1,6,14.31s-5.91,5.57-13.55,5.88Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,292.34v.05s-5.71,6-16.5,7.61c-9.86,1.45-20.23-2.18-21.95-2.82.3-6.45,1.08-20.23,1.47-27.28.15-2.65.25-4.35.25-4.35l0,0-1.94,1.88v-2.29s-1.68-21.71,13.43-25a21.7,21.7,0,0,0,11.5-2.63,21.92,21.92,0,0,1,2.51-.52,7.83,7.83,0,0,1,7.2,2.77,18.28,18.28,0,0,1,3.32,7.54c1.45,6.49-4.81,25.49-5.21,27.42S344.51,289.38,345,292.34Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.91,268.43s-7.61,9.65-10.78,11.18-24.94-14.45-27.78-15.69-9.71-4.13-10.73-5.59a6.26,6.26,0,0,1,1.2-5.59s.08-2.62,1.73-3.06c0,0-4.85-6.41-4.23-7.31s2.17-.36,3.61,1.11,7.46,9,8.15,9.26,1.16-2.45,2.29-4,2.87-1.55,2.82-.29-1.07,4.82-1,6.42,1.44,2.77,2.6,3.65,17.79,9.23,17.79,9.23l6.49-7.43",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.62,241.22s-4.55-.38-10,4.85-12,14.44-12,14.44a26.18,26.18,0,0,0,10.32,10.14S318,257.4,320.51,251,316.62,241.22,316.62,241.22Z",
    style: {
      fill: "#FB8CFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.62,241.22s-4.55-.38-10,4.85-12,14.44-12,14.44a26.18,26.18,0,0,0,10.32,10.14S318,257.4,320.51,251,316.62,241.22,316.62,241.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.38,311.17s.29,5.62.66,12.21v.05l.56-11.37a23.39,23.39,0,0,0,5.44-5.28A22.5,22.5,0,0,1,327.38,311.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,202.53s-2.08-2.8-6.17-.72c-5.5,2.81-.72,12.88-.72,12.88a13,13,0,0,1,6.08-8.53s-1,8.18-.73,10.83a4.85,4.85,0,0,0,1.69,3.54s1.14-3.12,3.76-2.1,3.27,7.45-2.26,8.24c0,0,2.71,5.21,5.35,6.15s8.12.4,10.88-2.55a25.21,25.21,0,0,0,4.15-5.89l1,.18s-.77,7,3,11.24a11.57,11.57,0,0,0,8.48,4.09,19.65,19.65,0,0,1-.66-5.77c.24-2.46,1.62-15.45-.39-19.84A9.15,9.15,0,0,0,338,209.33s-.83-5.09-7.13-7.74C320.81,197.36,316,202.53,316,202.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,209.33s-2.26-.68-3.34,4.13.08,10.44,4.37,11.1c0,0-5.32,1-6.64-4.35C331.28,215.75,332.08,207.51,338,209.33Z",
    style: {
      fill: "#FB8CFF"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateAmico);
export default __webpack_public_path__ + "static/media/Update-amico.c16f062c4045456b4d0f5e63f2f3cfa8.svg";
export { ForwardRef as ReactComponent };